import {
  BpkButtonV2,
  BUTTON_TYPES,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import {
  withLargeButtonAlignment,
  withButtonAlignment,
} from '@skyscanner/backpack-web/bpk-component-icon';

import withErrorBoundary from '../ErrorBoundary';
import Icon from '../common/Icon';

import type { ButtonProps } from '@skyscanner-internal/landing-pages-shared-types/src/types-shared/ButtonProps';

type ButtonContentProps = {
  label: string;
  icon: ButtonProps['icon'];
  size: ButtonProps['size'];
};

const ButtonContent = ({ icon, label, size }: ButtonContentProps) => {
  if (!icon) {
    return <>{label}</>;
  }

  const IconComponent =
    size === 'large'
      ? withLargeButtonAlignment(Icon(icon, size))
      : withButtonAlignment(Icon(icon, size));

  // The arrow icon is a special case, as it needs to be aligned to the right of the label
  if (icon === 'arrow') {
    return (
      <>
        {label}&nbsp;
        <IconComponent />
      </>
    );
  }

  // All other icons are aligned to the left of the label
  return (
    <>
      <IconComponent />
      &nbsp;{label}
    </>
  );
};

const Button = ({ href, icon, label, size, type }: ButtonProps) => (
  <BpkButtonV2 type={BUTTON_TYPES[type]} size={SIZE_TYPES[size]} href={href}>
    <ButtonContent icon={icon} label={label} size={size} />
  </BpkButtonV2>
);
const ButtonWithErrorBoundary = withErrorBoundary(Button, 'button-component');

export default ButtonWithErrorBoundary;
